import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

import Map from './Map';
import { Box, MenuItem } from '@mui/material';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    marginTop: 20,
    borderRadius: 25,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const AgentAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
  allCountry,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [status, setStatus] = useState(false);
  const [name, setName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [openTime, setOpenTime] = useState('');
  const [closeTime, setCloseTime] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const [businessCountry, setBusinessCountry] = useState('');
  const [businessStreet, setBusinessStreet] = useState('');
  const [postalZip, setPostalZip] = useState('');
  const [agentFindUsFrom, setAgentFindUsFrom] = useState('');
  const [typeOfBusiness, setTypeOfBusiness] = useState('');

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const validation = () => {
    let isError = false;
    if (!name.trim()) {
      // console.log('name');
      handleSnakbarOpen('Please enter bank name', 'error');
      document.getElementById('name').focus();
      return (isError = true);
    }

    // console.log('finish');
    return isError;
  };
  const clearStates = () => {
    setId('');
    setName('');
    setStatus(false);
    setEditObj({});
  };

  const handleSubmit = async e => {
    // console.log('editIndexNo', editIndexNo);
    e.preventDefault();

    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let location = [];
    if (localStorage.getItem('lat')) {
      location['lat'] = localStorage.getItem('lat');
    } else {
      location['lat'] = latitude;
    }
    if (localStorage.getItem('lon')) {
      location['lon'] = localStorage.getItem('lon');
    } else {
      location['lon'] = longitude;
    }
    let formData = {
      status,
      name,
      firstName,
      lastName,
      mobileNumber,
      email,
      address,
      openTime,
      closeTime,
      latitude: location['lat'],
      longitude: location['lon'],

      businessStreet,
      businessCountry,
      postalZip,
      agentFindUsFrom,
      typeOfBusiness,
    };
    try {
      if (addForm) {
        response = await axios({
          url: `/api/v1/private/agent`,
          method: 'post',
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log('addForm Submit', name, status);
        setList([...list, response.data.data]);
        clearStates();
        // console.log('addForm response', response);
      } else if (editForm) {
        response = await axios({
          url: `/api/v1/private/agent/${id}`,
          method: 'put',
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log('editForm Submit', id, name, status);
        // console.log('editForm response', response);

        list[editIndexNo] = response.data.data;
        setRefresh(!refresh);
      }

      closeAddDialog();
      activeAddForm();
      handleSnakbarOpen(response.data.message, 'success');
      localStorage.setItem('lat', '');
      localStorage.setItem('lon', '');
    } catch (error) {
      // console.log('error', error);
      // console.log('errorresponse', error.response);

      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  const getLocation = () => {
    setLatitude(43.651605);
    setLongitude(-79.383125);
    // navigator.geolocation.getCurrentPosition(function(position) {
    //   console.log('Latitude is :', position.coords.latitude);
    //   console.log('Longitude is :', position.coords.longitude);
    //   setLatitude(position.coords.latitude);
    //   setLongitude(position.coords.longitude);
    // });
  };

  useEffect(() => {
    if (editObj.id) {
      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setStatus(editObj.status);
      setName(editObj.name);
      setFirstName(editObj.firstName);
      setLastName(editObj.lastName);
      setMobileNumber(editObj.mobileNumber);
      setEmail(editObj.email);
      setAddress(editObj.address);
      setOpenTime(editObj.openTime);
      setCloseTime(editObj.closeTime);
      setLatitude(editObj.latitude);
      setLongitude(editObj.longitude);

      setBusinessStreet(editObj.businessStreet);
      setBusinessCountry(editObj.businessCountry);
      setPostalZip(editObj.postalZip);
      setAgentFindUsFrom(editObj.agentFindUsFrom);
      setTypeOfBusiness(editObj.typeOfBusiness);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();

    // setEditForm(false);
    // setAddForm(true);
  };
  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);

  useEffect(() => {
    getLocation();
  }, []);

  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        {editForm && (
          <div className={classes.iconDiv}>
            <IconButton aria-label="close" color="inherit" size="small" onClick={activeAddForm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          {editForm ? 'Update Bank' : 'Add Bank'}
        </Typography>
      </div> */}
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Agent' : 'Add Agent'}
        </Typography>
      </div>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Business Name"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={name}
          onChange={e => setName(e.target.value)}
        />

        {!editForm && (
          <div>
            <TextField
              label="First name"
              variant="outlined"
              fullWidth
              required
              size="small"
              className={`${classes.marginStyle} ${classes.inputStyle}`}
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
            />

            <TextField
              label="Last Name"
              variant="outlined"
              fullWidth
              required
              size="small"
              className={`${classes.marginStyle} ${classes.inputStyle}`}
              value={lastName}
              onChange={e => setLastName(e.target.value)}
            />

            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              required
              size="small"
              className={`${classes.marginStyle} ${classes.inputStyle}`}
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
        )}

        <TextField
          label="Mobile Number"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={mobileNumber}
          onChange={e => setMobileNumber(e.target.value)}
        />

        <TextField
          label="Address"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={address}
          onChange={e => setAddress(e.target.value)}
        />

        <TextField
          label="Open Time"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={openTime}
          onChange={e => setOpenTime(e.target.value)}
        />

        {/* businessStreet, businessCountry, postalZip, agentFindUsFrom, typeOfBusiness; */}
        <TextField
          label="Close Time"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={closeTime}
          onChange={e => setCloseTime(e.target.value)}
        />
        <TextField
          label="Business Street"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={businessStreet}
          onChange={e => setBusinessStreet(e.target.value)}
        />

        <TextField
          label="Postal Zip"
          variant="outlined"
          fullWidth
          required
          size="small"
          className={`${classes.marginStyle} ${classes.inputStyle}`}
          value={postalZip}
          onChange={e => setPostalZip(e.target.value)}
        />

        <TextField
          variant="outlined"
          select
          label="Business Country"
          size="small"
          fullWidth
          required
          value={businessCountry}
          onChange={e => setBusinessCountry(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          {allCountry.map((e, index) => (
            <MenuItem value={e.name} key={index}>
              <Box className={classes.inner}>
                <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.name}
              </Box>
            </MenuItem>
          ))}
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Agent Find Us From"
          size="small"
          fullWidth
          required
          value={agentFindUsFrom}
          onChange={e => setAgentFindUsFrom(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value="Advertisement">Advertisement</MenuItem>
          <MenuItem value="Social_Media">Social Media</MenuItem>
          <MenuItem value="Word_Of_Mouth">Word Of Mouth</MenuItem>
          <MenuItem value="GlobPay_Sales_Representative">GlobPay Sales Representative</MenuItem>
          <MenuItem value="GlobPay_Website">GlobPay Website</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>

        <TextField
          variant="outlined"
          select
          label="Type Of Business"
          size="small"
          fullWidth
          required
          value={typeOfBusiness}
          onChange={e => setTypeOfBusiness(e.target.value)}
          className={`${classes.marginStyle} ${classes.inputStyle}`}>
          <MenuItem value="Check_Casher">Check Casher</MenuItem>
          <MenuItem value="Convenience_Store">Convenience Store</MenuItem>
          <MenuItem value="Ethnic_Grocery">Ethnic Grocery</MenuItem>
          <MenuItem value="Grocery">Grocery</MenuItem>
          <MenuItem value="Liquor_Store">Liquor Store</MenuItem>
          <MenuItem value="Multi_Service">Multi Service</MenuItem>
          <MenuItem value="Pharmacy">Pharmacy</MenuItem>
          <MenuItem value="Port">Port</MenuItem>
          <MenuItem value="Biller">Biller</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>

        <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
          <FormControlLabel
            control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
            label="Status"
            labelPlacement="start"
          />
        </div>

        {/* map  */}

        {latitude && longitude ? (
          <Map
            center={{ lat: latitude, lng: longitude }}
            height="300px"
            zoom={15}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
          />
        ) : (
          'map loading ...'
        )}

        <div className={classes.buttonMarginStyle}>
          {/* {loading ? <LinearProgress /> : null} */}

          <Button
            variant="contained"
            className={classes.buttonStyle}
            color="primary"
            disabled={loading}
            fullWidth
            type="submit">
            {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
            {editForm ? 'Update' : 'Save'}
          </Button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default AgentAddEdit;
